import { ISchedule } from "./types";
import { format } from "date-fns";

export const getOriginLocationString = (row: ISchedule, useShortLocation: boolean = false, onlyfortransferextract: boolean = false) => {
    let originLocation = "";
    if (useShortLocation && row.originLocationShortName != null && row.originLocationShortName != "") {
        originLocation = row.originLocationShortName;
    } else if (row.originLocationName != null && row.originLocationName != "") {
        //return row.originLocationName;
        originLocation = row.originLocationName;
    } else if (row.originName != null && row.originName != "") {
        //return row.originName;
        originLocation = row.originName;
    } else if (row.originCustLocationGeoName != null && row.originCustLocationGeoName != "") {
        //return row.originCustLocationGeoName;
        originLocation = row.originCustLocationGeoName;
    } else if (row.originGooglePlaceId != null) {
        //return `${row.originStreetAddress ?? ""} ${row.originSuburb ?? ""} ${row.originState ?? ""}`;
        originLocation = `${row.originStreetAddress ?? ""} ${row.originSuburb ?? ""} ${row.originState ?? ""}`;
    } else if (row.originCustomerLocationId) {
        //return `${row.originLocationName}${row.originWardName ? ` / ${row.originWardName}` : ""}${row.originBed ? ` / ${row.originBed}` : ""}`;
        originLocation = row.originLocationName;
    } else {
        return null;
    }

    //add ward
    let originLocationWard = "";
    if (row.originWardName != null && row.originWardName != "") {
        originLocationWard = ' / ' + row.originWardName;
    }
    //add bed
    let originLocationBed = "";
    if (row.originBed != null && row.originBed != "") {
        originLocationBed = ' / ' + row.originBed;
    }
    if(onlyfortransferextract)
        return originLocation
    else
        return originLocation + originLocationWard + originLocationBed;
};

export const getDestinationLocationString = (row: ISchedule, useShortLocation: boolean = false, onlyfortransferextract: boolean = false) => {
    let destinationLocation = "";
    if (useShortLocation && row.destinationLocationShortName != null && row.destinationLocationShortName != "") {
        destinationLocation = row.destinationLocationShortName;
    } else if (row.destinationLocationName != null && row.destinationLocationName != "") {
        //return row.destinationLocationName;
        destinationLocation = row.destinationLocationName;
    } else if (row.destinationName != null && row.destinationName != "") {
        //return row.destinationName;
        destinationLocation = row.destinationName;
    } else if (row.destinationCustLocationGeoName != null && row.destinationCustLocationGeoName != "") {
        //return row.destinationCustLocationGeoName;
        destinationLocation = row.destinationCustLocationGeoName;
    } else if (row.destinationGooglePlaceId != null) {
        //return `${row.destinationStreetAddress ?? ""} ${row.destinationSuburb ?? ""} ${row.destinationState ?? ""}`;
        destinationLocation = `${row.destinationStreetAddress ?? ""} ${row.destinationSuburb ?? ""} ${row.destinationState ?? ""}`;
    } else if (row.destinationCustomerLocationId) {
        //return `${row.destinationLocationName}${row.destinationWardName ? ` / ${row.destinationWardName}` : ""}${row.destinationBed ? ` / ${row.destinationBed}` : ""}`;
        destinationLocation = row.destinationLocationName;
    } else {
        return null;
    }

    //add ward
    let destinationLocationWard = "";
    if (row.destinationWardName != null && row.destinationWardName != "") {
        destinationLocationWard = ' / ' + row.destinationWardName;
    }
    //add bed
    let destinationLocationBed = "";
    if (row.destinationBed != null && row.destinationBed != "") {
        destinationLocationBed = ' / ' + row.destinationBed;
    }

    if(onlyfortransferextract)
        return destinationLocation
    else
        return destinationLocation + destinationLocationWard + destinationLocationBed;
};

export const getAcuity = (row: ISchedule) => {
    if (row.classification === 1)
        return "B";
    else if (row.classification === 2)
        return "C";
    else if (row.classification === 3)
        return "D";
    else if (row.classification === 4)
        return "E";
    else if (row.classification === 5)
        return "H";
    else if (row.classification === 6)
        return "M";
    else if (row.classification === 7)
        return "L";
    return "";
}

export const parseJwt = (token: string) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
};

export const isItTablet1280x800inLandscape = (windowWidth: number) =>{
    if(!windowWidth)
        return false;

    if(windowWidth <= 1280)
        return true;
    return false;
};

export const getTimeFromDate = (date: any): string => {
    date = new Date(date);
    return `${("0" + date.getHours()).slice(-2)}:${("0" + date.getMinutes()).slice(-2)}`;
}

export const getTimeFromDatebyZone = (date: any,zone :any): string => {
    var str = new Date(date).toLocaleString('en-US', { timeZone: zone });
    return `${format(Date.parse(str), "HH:mm")}`; 
}

